<template>
  <div class="menuBox">
    <a-menu
      mode="inline"
      :open-keys="openKeys"
      class="menuWapper"
      @openChange="onOpenChange"
      :defaultSelectedKeys="selectedKeys"
      theme="light"
      :inline-collapsed="collapsed"
    >
      <a-sub-menu v-for="item in Object.keys(menuMap)" :key="item">
        <span slot="title">
          <a-icon :type="menuMap[item].icon || 'appstore'" />
          <span>{{ item }}</span>
        </span>
        <a-menu-item  style="background: none;"
          v-for="it in menuMap[item].children"
          :key="it.path"
          @click="clickMenu(it)"
          >{{ it.menuName }}
        </a-menu-item>
      </a-sub-menu>
    </a-menu>
    <span class="arrowWapper" @click="toggleCollapsed">
      <a-icon :type="menuArrow" :style="{ fontSize: '20px', color: '#999' }" />
    </span>
  </div>
</template>
<script>
import { subRouter } from '@router/routers';
export default {
  name: 'Menu',
  props: {},

  data() {
    return {
      menuMap: {},
      openKeys: [],
      selectedKeys: [this.$route.path],
      collapsed: false,
      menuArrow: 'left',
    };
  },

  components: {},

  mounted() {
    console.log('subRouter111111', subRouter);
    let menuMap = {};
    let openKeys = [];
    subRouter.forEach((item, index) => {
      const { parent, menuName, hidden, icon } = item.meta;
      const path = item.path;
      
      // Skip hidden menu items
      if (hidden) {
        return;
      }

      if (index == 0) {
        openKeys = [parent];
      }
      
      if (menuMap[parent]) {
        menuMap[parent].children.push({
          path,
          menuName,
        });
      } else {
        menuMap[parent] = {
          icon: icon || 'appstore',
          children: [{
            path,
            menuName,
          }]
        };
      }
    });
    this.menuMap = menuMap;
    this.openKeys = openKeys;
    console.log('menuMap', this.menuMap);
  },
  watch: {},

  methods: {
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );

      this.openKeys = latestOpenKey ? [latestOpenKey] : [];
    },

    clickMenu(info) {
      console.log(info, 'info');
      // Only navigate if the path is different from current path
      if (this.$route.path !== info.path) {
        this.$router.replace(info.path);
      }
    },

    toggleCollapsed() {
      this.collapsed = !this.collapsed;
      this.menuArrow = this.menuArrow == 'right' ? 'left' : 'right';
    },
  },
};
</script>

<style lang="less" scoped>
.menuBox {
  margin-top: 10px;
  height: 100%;
  position: relative;
  background: #fff;
  .arrowWapper {
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translate(100%, -50%);
    // background: #cdd0d4;
    cursor: pointer;
    padding: 8px 0;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    background: #fff;
    border-radius: 5px 0px 0px 5px;
  }
}
.menuWapper {
  width: 100%;
  height: 100%;
}


</style>
